var map = {
	"./ukraine_full_desk.jpg": 5831,
	"./ukraine_full_desk_dm.jpg": 7465,
	"./ukraine_full_mob.jpg": 3588,
	"./ukraine_full_mob_dm.jpg": 9376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9759;